export const theme = {
  accentPrimary: '#ff7500',
  accentPrimaryHover: 'rgb(204, 94, 0)',
  accentPrimarySoft: '#fff0e5',
  accentPrimaryHex: '#ff7500',
  pageBackground: '#FCF8F2',
  backgroundColor: '#FCF8F2',
};

export function buildAvatarUrl(name, size = 60) {
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || 'U')}&background=${theme.accentPrimaryHex}&color=fff&size=${size}`;
}
